import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.labDashboard || initialState;

export const selectCommodities = createSelector(
  [selectDomain],
  (state) => state.commodities
);

export const selectOrderCountAnalytic = createSelector(
  [selectDomain],
  (state) => state.orderCountAnalytic
);

export const selectOrderByStage = createSelector(
  [selectDomain],
  (state) => state.orderByStage
);

export const selectCommodityWiseOrders = createSelector(
  [selectDomain],
  (state) => state.commodityWiseOrders
);

export const selectRejectedOrders = createSelector(
  [selectDomain],
  (state) => state.rejectedOrders
);

export const selectDisputeAnalysis = createSelector(
  [selectDomain],
  (state) => state.disputeAnalysis
);

export const selectReportReviewStatus = createSelector(
  [selectDomain],
  (state) => state.reportReviewStatus
);